// @ts-nocheck
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function initLeafletMaps() {
    return __awaiter(this, void 0, void 0, function* () {
        if (window.mapInitialized)
            return;
        const leafletItems = document.querySelectorAll("[data-leaflet]");
        if (!leafletItems.length)
            return;
        const [{ default: L }, { GestureHandling }] = yield Promise.all([
            import(/* webpackChunkName: "leaflet" */ "leaflet"),
            import(/* webpackChunkName: "leaflet" */ "leaflet-gesture-handling"),
        ]);
        window.mapInitialized = true;
        L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
        leafletItems.forEach((item) => {
            const map = L.map(item, {
                center: [51.6218587987563, 5.516838267135705],
                zoom: 14,
                preferCanvas: true,
                zoomControl: false,
                gestureHandling: true,
            });
            L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=cb1_2ajg_1_1173f3e8d5cc1b71117c10a6", {
                attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
                maxZoom: 19,
            }).addTo(map);
            const mapIcon = L.icon({
                iconUrl: "/wp-content/themes/tibeg/assets/img/icons/location.svg",
                iconSize: [40, 40],
                iconAnchor: [20, 40],
                popupAnchor: [-3, -76],
                shadowSize: [0, 0],
                shadowAnchor: [22, 94],
            });
            L.marker([51.6218587987563, 5.516838267135705], {
                icon: mapIcon,
                opacity: 1,
            }).addTo(map);
        });
    });
}
export default initLeafletMaps;
